import { render } from "./FileBrowser.vue?vue&type=template&id=7b51e103"
import script from "./FileBrowser.vue?vue&type=script&lang=js"
export * from "./FileBrowser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Files/FileBrowser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b51e103"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b51e103', __exports__)) {
    console.log('reload')
    api.reload('7b51e103', __exports__)
  }
  
  module.hot.accept("./FileBrowser.vue?vue&type=template&id=7b51e103", () => {
    console.log('re-render')
    api.rerender('7b51e103', render)
  })

}


export default __exports__